'use strict';

import cookies from 'js-cookie';
var _ = require('underscore');
var config = require('../../js/config');
var utilities = require('../../js/utilities');
var ServerErrorResponseModel = require('../../js/ServerErrorResponseModel');
var GenericController = require('../../js/GenericController');
var $ = require('jquery');
var websiteLang = cookies.get(config.cookies.arrowLanguage);

const TYPEAHEAD_CACHE_KEY = 'typeaheadSearchResults_' + websiteLang;
const TYPEAHEAD_AJAX_TIMEOUT = 10000;
const TYPEAHEAD_SEARCH_DEBOUNCE = 300;

var TypeaheadController = GenericController.extend({

  initialize: function() {

    // Bind mediator events
    this.bindMediatorEvents();

    // Setup search results for caching initialization, our search terms should be saved in session storage
    // if we don't find any, lets default to an empty object to start local caching, each time we do a search
    // we will save it in this sessionStorage for later lookup in the users session
    this.searchResults = utilities.sessionStorageLoad(TYPEAHEAD_CACHE_KEY) || {};

    // Initialize and Setup for search navigation
    this.resetSearchResultNavigation();

    // Setup debounce so we don't hit the api all of the time
    this.updateSearch = _.debounce(this.updateSearch, TYPEAHEAD_SEARCH_DEBOUNCE);
  },

  resetSearchResultNavigation: function() {
    // Current index for arrow navigation
    this.currentSearchIndex = 0;

    // flag to not skip over the first result when using the arrow keys to navigate
    this.isFirstResultToggle = true;

    // Current query for caching
    this.currentQuery = null;

    this.storedRecentSearches = utilities.localStorageLoad(config.events.search.localStorageTypeAhead);
    if (this.storedRecentSearches !== null && typeof(this.storedRecentSearches) === 'string')
    {
      this.indexCount = this.storedRecentSearches.split(',');
    }
  },

  getQueryResults: function(query) {
    return this.searchResults[query].results;
  },

  bindMediatorEvents: function() {
    this.mediator.on(config.events.search.typeaheadSearch, _.debounce(this.updateSearch, TYPEAHEAD_SEARCH_DEBOUNCE), this);
    this.mediator.on(config.events.search.typeaheadChoosePrevious, this.highlightPrevious, this);
    this.mediator.on(config.events.search.typeaheadChooseNext, this.highlightNext, this);
    this.mediator.on(config.events.search.typeaheadChoosePreviousRecent, this.highlightPreviousRecent, this);
    this.mediator.on(config.events.search.typeaheadChooseNextRecent, this.highlightNextRecent, this);
    this.mediator.on(config.events.search.close, this.resetSearchResultNavigation, this);
  },

  highlightPrevious: function() {

    // Determine if we can tab through our results and if we are in the first navigation
    if (this.hasResultsAndIsFirstNavigation()) {
      return;
    }

    // We are checking the bounds of the search results, checking our current index and deciding how to itterate
    if (this.currentSearchIndex > 0) {
      this.currentSearchIndex--;
    }
    else {
      this.currentSearchIndex = this.searchResultsLength - 1;
    }

    this.highlightResult(this.currentSearchIndex);
  },

  highlightPreviousRecent: function() {

    // Determine if we can tab through our results and if we are in the first navigation
    if (this.hasResultsAndIsFirstNavigationRecent()) {
      return;
    }

    // We are checking the bounds of the search results, checking our current index and deciding how to itterate
    if (this.currentSearchIndex > 0) {
      this.currentSearchIndex--;
    }
    else {
      this.currentSearchIndex = this.indexCount.length - 1;
    }

    this.highlightResult(this.currentSearchIndex);
  },

  highlightNext: function() {

    // Determine if we can tab through our results and if we are in the first navigation
    if (this.hasResultsAndIsFirstNavigation(true)) {
      return;
    }

    // We are checking the bounds of the search results, checking our current index and deciding how to itterate
    if (this.currentSearchIndex < this.searchResultsLength - 1) {
      this.currentSearchIndex++;
    }
    else {
      this.currentSearchIndex = 0;
    }

    this.highlightResult(this.currentSearchIndex);
  },

  highlightNextRecent: function() {

    // Determine if we can tab through our results and if we are in the first navigation
    if (this.hasResultsAndIsFirstNavigationRecent(true)) {
      return;
    }

    // We are checking the bounds of the search results, checking our current index and deciding how to itterate
    if (this.currentSearchIndex < this.indexCount.length - 1) {
      this.currentSearchIndex++;
    }
    else {
      this.currentSearchIndex = 0;
    }

    this.highlightResult(this.currentSearchIndex);
  },

  hasResultsAndIsFirstNavigationRecent: function(isDown) {
    // If we don't have any results, we have nothing to iterate over, let's get out of here
    if (this.indexCount.length === 0) return true;

    if (this.isFirstResultToggle) {
      // Set the flag as false so we know we are no longer in the first navigation state
      this.isFirstResultToggle = false;
      // If we are on our first "next" navigation, we want to start at the 0th index so we don't skip over the first one
      if (isDown) {
        // Set the first search to be highlighted
        this.highlightResult(0);
        return true;
      }
    }
  },

  hasResultsAndIsFirstNavigation: function(isDown) {

    // If we don't have any results, we have nothing to iterate over, let's get out of here
    if (this.searchResultsLength === 0) return true;

    if (this.isFirstResultToggle) {
      // Set the flag as false so we know we are no longer in the first navigation state
      this.isFirstResultToggle = false;
      // If we are on our first "next" navigation, we want to start at the 0th index so we don't skip over the first one
      if (isDown) {
        // Set the first search to be highlighted
        this.highlightResult(0);
        return true;
      }
    }
  },

  highlightResult: function(index) {
    // Triggers event which is captured in AutoCompleteView which will add the is-active class to the search result
    this.mediator.trigger(config.events.search.typeaheadHighlightQuery, index);
  },

  updateSearch: function(queryTerm, categoryValue) {

    let query = queryTerm;
    query = queryTerm + '|' + categoryValue;
    // Set the query so we know what state we are in
    this.currentQuery = query;

    // Check to see if we have the search results cached
    if (this.searchResults[query]) {

      // get the results from our local cache'ed variable
      let results = this.getQueryResults(query);
      this.handleResults(query, results);

    } else {
      let url = config.urls.searchApp.url + config.urls.searchApp.autoComplete;
      let queryData = utilities.addCustIpToDataObject({
        q: queryTerm,
        category: categoryValue,
        lang: websiteLang
      });


      queryData = utilities.addCustIpToDataObject({
        q: queryTerm,
        category: categoryValue,
        lang: websiteLang,
        url: config.productAPI.baseUrl
      });

      $.ajax({
        url: url,
        dataType: 'json',
        handleErrorLocally: true,
        timeout: TYPEAHEAD_AJAX_TIMEOUT,
        data: queryData,
        success: _.bind(function(response) {

          let results = response.data.results;

          this.handleResults(query, results);

        }, this),
        error: _.bind(function($xhr, statusText) {
          if (statusText !== 'timeout') {
            this.checkResponseStatus($xhr.status);
          }
          var err = ServerErrorResponseModel.createFromXHR($xhr);
          this.mediator.trigger(config.events.search.typeaheadSearchFailed, query, err);
        }, this)
      });
    }
  },

  handleResults: function(query, results) {
    // Trigger mediator event to let others know we have retrieved results
    this.mediator.trigger(config.events.search.fetchedTypeaheadResults, query, results);

    // save results
    this.setSearchResults(query, results);
  },

  setSearchResults: function(query, results) {

    // check to see if we have already handle the results
    if (!this.searchResults[query]) {

      // setup results count to know how many results we have
      let resultsCount = 0;


      // Iterate over our results and get result size
      _.each(results, (arr) => {
        resultsCount += _.size(arr);
      }, this);

      // save results in our local results variable with a key of the query for later lookup
      this.searchResults[query] = {
        results,
        resultsCount
      };

      // Save to session storage
      utilities.sessionStorageSave(TYPEAHEAD_CACHE_KEY, this.searchResults);
    }

    // Set the result length
    this.searchResultsLength = this.searchResults[query].resultsCount;

    this.displaySearchResults(query, this.searchResults[query]);
  },

  displaySearchResults: function(query, searchResults) {

    // Tell everyone we want to display some results
    this.mediator.trigger(config.events.search.typeaheadDisplayResults, {
      query,
      results: searchResults.results,
      resultsCount: searchResults.resultsCount
    });

    // Reset for handle more search results
    this.resetSearchResultNavigation();
  }
});

module.exports = TypeaheadController;



// WEBPACK FOOTER //
// ./assets/components/Typeahead/TypeaheadController.js